import { render, staticRenderFns } from "./OrgListEmployee.vue?vue&type=template&id=313bf71e&scoped=true"
import script from "./OrgListEmployee.vue?vue&type=script&lang=js"
export * from "./OrgListEmployee.vue?vue&type=script&lang=js"
import style0 from "./OrgListEmployee.vue?vue&type=style&index=0&id=313bf71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313bf71e",
  null
  
)

export default component.exports